var map = {
	"./zh/about.json": 7173,
	"./zh/common.json": 4798,
	"./zh/contact.json": 6849,
	"./zh/home.json": 7990,
	"./zh/products.json": 5376,
	"./zh/support.json": 7878,
	"./zh/trial.json": 1408
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3509;